import { AxiosResponse } from 'axios';
import { useQuery } from 'react-query';

// configs
import { API } from 'configs/api';
import { IVideoReply, IVideoReplyResponse } from './types';
import { videoReplyKeys } from './videoReplyKeys';

export const getVideoReply = async ({ eridEncoded, shortUrl }: IVideoReply) => {
  const response: AxiosResponse<any> = await API.get<IVideoReplyResponse>(
    `/video-reply/${shortUrl}/erid/${eridEncoded}`
  );

  return response.data;
};

export const useVideoReplyQuery = ({ eridEncoded, shortUrl }: IVideoReply) => {
  return useQuery<IVideoReplyResponse, Error>(
    videoReplyKeys.all(),
    () => getVideoReply({ eridEncoded, shortUrl }),
    {
      enabled: !!eridEncoded && !!shortUrl,
      cacheTime: 0,

      onError: () => {
        console.log(`error video reply  `);
      },
    }
  );
};
